<template>
  <div>
    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-textarea
      label="Description"
      v-model="form.description"
      :validation-errors="validationErrors.description"
    ></form-field-textarea>

    <form-field-editor
      label="Subject"
      v-model="form.subject"
      type="shortCodesOnly"
      is-single-line
      short-code-type="record"
      :validation-errors="validationErrors.subject"
    ></form-field-editor>

    <form-field-editor
      label="Body"
      v-model="form.body"
      :validation-errors="validationErrors.body"
      type="snippetEmail"
      short-code-type="record"
    ></form-field-editor>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import {ENUMS} from "../services/enums";

export default {
  name: "SnippetEmailForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        account_id: this.$store.getters.account.id,
        label: '',
        description: '',
        subject: '',
        body: '',
        type: ENUMS.SnippetTypeEnum.Email.value,
      },
    }
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone(this.formData) : this.$utils.clone(this.defaultForm);
  },
  methods: {
    update() {
      return this.$api.snippets.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Snippet was updated',
            type: 'is-success'
          });

          return res;
        });
    },
    create() {
      return this.$api.snippets.create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Snippet was created',
            type: 'is-success'
          });

            return res;
          });
    },
    delete() {
      return this.$api.snippets.delete(this.form.id)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Snippet was archived',
            type: 'is-success'
          });

            return res;
          });
    },
  },
}
</script>

<style scoped>

</style>
